import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminDeleteProviderDepartmentOptionMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminDeleteProviderDepartmentOptionMutationResultFragment, AdminDeleteProviderDepartmentOptionMutationParams } from '@docpace/admin-graphql'

const typedAdminDeleteProviderDepartmentOptionMutationDocument = AdminDeleteProviderDepartmentOptionMutationDocument as TypedDocumentNode<AdminDeleteProviderDepartmentOptionMutationResultFragment, Partial<AdminDeleteProviderDepartmentOptionMutationParams>>

export function useAdminDeleteProviderDepartmentOptionMutation(opts?: useMutation.Options<AdminDeleteProviderDepartmentOptionMutationResultFragment, Partial<AdminDeleteProviderDepartmentOptionMutationParams>>){
    return useMutation(typedAdminDeleteProviderDepartmentOptionMutationDocument, opts)
}
